// extracted by mini-css-extract-plugin
module.exports = {"container":"_2NdkMNtCRar9LFKaccUzQA","icon":"_1Ajr0_iITv1olirh7ThhaY"};